import { CommandError } from './errors.js';
import { handlerFor, HANDLED_COMMAND_TYPES } from './commands/registry.js';
export { CommandError } from './errors.js';
export * from './commands/types.js';
export * from './commands/projection.js';
export { COMMAND_HANDLERS, HANDLED_COMMAND_TYPES } from './commands/registry.js';
/**
 * Declared in the catalogue, handler not yet written — the P3 work list, in code.
 *
 * The API validates these shapes and then rejects them, rather than half-applying something. An
 * honest refusal beats a silent no-op: a command that parses and does nothing is far worse than one
 * that says it is not available.
 */
/** Every command in the catalogue now executes. */
export const PENDING_COMMAND_TYPES = [];
/** Which slices a command's handler reads, so the server loads exactly those and no more. */
export function slicesFor(type) {
    return handlerFor(type)?.needs ?? [];
}
export function applyCommand(slice, command, ctx) {
    const handler = handlerFor(command.type);
    if (!handler) {
        const type = command.type;
        throw new CommandError('invalid', PENDING_COMMAND_TYPES.includes(type)
            ? `Command "${type}" is declared but not yet implemented`
            : `Unhandled command: ${type}`);
    }
    return handler.apply(slice, command, ctx);
}
/** Every command that can actually be executed today. */
export function isImplemented(type) {
    return HANDLED_COMMAND_TYPES.includes(type);
}
//# sourceMappingURL=reducer.js.map